module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.template) ? _c('document-container', {
    attrs: {
      "footer": _vm.template.footer(),
      "header": _vm.template.header(),
      "logo": _vm.logo,
      "timeout": 3000,
      "documentType": "factsheet"
    }
  }, [_c('div', {
    staticClass: "factsheet-table page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h2', [_vm._v("Strategie")]), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(_vm.product.specific ? _vm.product.specific.strategy : 'Leider steht zu diesem Produkt keine Strategie zur Verfügung.') + "\n        ")])]), _vm._v(" "), (_vm.product.issuer) ? _c('div', {
    staticClass: "column is-3"
  }, [_c('h2', [_vm._v("Anschrift")]), _vm._v("\n        " + _vm._s(_vm.product.issuer.issuerName)), _c('br'), _vm._v(" " + _vm._s(_vm.product.issuer.issuerStreet)), _c('br'), _vm._v("\n        " + _vm._s(_vm.product.issuer.issuerPostalCode) + " " + _vm._s(_vm.product.issuer.issuerCity) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.product.issuer.issuerUrl) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "factsheet-table page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-5",
    staticStyle: {
      "padding-right": "20px"
    }
  }, [_c('h2', [_vm._v("Produkt in Zahlen")]), _vm._v(" "), _c('div', _vm._l((_vm.filteredBaseTable), function(field) {
    return _c('div', {
      staticClass: "columns field"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('strong', [_vm._v(_vm._s(field.label))])]), _vm._v(" "), _c('tablefield-' + field.fieldType, {
      tag: "div",
      staticClass: "column basetable-field",
      attrs: {
        "config": _vm.getFieldConfig(field),
        "data": _vm.getFieldData(field.key),
        "product": _vm.product
      }
    })], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "column is-7"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('chart-container', {
    attrs: {
      "slot": "raw-body",
      "chartData": _vm.developmentChart,
      "chartType": 'ChartHistory',
      "heading": 'Kursentwicklung',
      "settings": {
        style: {
          width: 380,
          height: 150
        }
      }
    },
    slot: "raw-body"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [(_vm.mifidPerformance) ? _c('chart-container', {
    attrs: {
      "chart-data": _vm.mifidPerformance,
      "settings": {
        style: {
          height: 110,
          width: 380
        }
      },
      "chart-type": "ChartVerticalBar",
      "heading": "5 Jahresentwicklung (%)"
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    staticStyle: {
      "padding-bottom": "0"
    },
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('h3', [_vm._v("Wertentwicklung des Fonds")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('table', {
    staticClass: "table is-narrow table-report-development"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Year-to-Date")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("1 Monat")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("6 Monate")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("1 Jahr")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("3 Jahre")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("5 Jahre")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("10 Jahre")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.performanceTable), function(row) {
    return _c('tr', {
      staticClass: "field underlying"
    }, [_c('th', [_c('strong', [_vm._v(_vm._s(row.label))])]), _vm._v(" "), _vm._l((['YTD', 'P1M', 'P6M', 'P1Y', 'P3Y', 'P5Y', 'P10Y']), function(time) {
      return _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_c('tablefield-percent', {
        attrs: {
          "data": row.data[time]
        }
      })], 1)
    })], 2)
  }), 0)])])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    staticStyle: {
      "padding-bottom": "0"
    },
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('h3', [_vm._v("Kennzahlen in Fondswährung")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v("Max Draw Down 5 Jahre")]), _vm._v(" "), _c('td', [_c('tablefield-percent', {
    attrs: {
      "data": _vm.getFieldData('fundCurrencyFigures.maximumDrawDownFiveYears.value')
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("Max Time to Recovery 5 Jahre")]), _vm._v(" "), _c('td', [_c('tablefield-text', {
    attrs: {
      "data": _vm.getFieldData('fundCurrencyFigures.maximumTimeToRecoverFiveYears.value') + ' Tage'
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Max Draw Down Auflage")]), _vm._v(" "), _c('td', [_c('tablefield-percent', {
    attrs: {
      "data": _vm.getFieldData('fundCurrencyFigures.maximumDrawDownSinceInception.value')
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("Value-at-Risk 1 Jahr")]), _vm._v(" "), _c('td', [_c('tablefield-percent', {
    attrs: {
      "data": _vm.getFieldData('fundCurrencyFigures.valueAtRiskOneYear.value')
    }
  })], 1)])])])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    staticStyle: {
      "padding-bottom": "0"
    },
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('h3', [_vm._v("Kennzahlen in Euro")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('table', {
    staticClass: "table is-narrow table-report-development"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("1 Jahr")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("3 Jahre")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("5 Jahre")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("10 Jahre")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.riskTable), function(row) {
    return _c('tr', {
      staticClass: "field underlying"
    }, [_c('td', [_c('strong', [_vm._v(_vm._s(row.label))])]), _vm._v(" "), _vm._l((['P1Y', 'P3Y', 'P5Y', 'P10Y']), function(time) {
      return _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_c('tablefield-percent', {
        attrs: {
          "data": row.data && row.data[time] ? row.data[time].value : null
        }
      })], 1)
    })], 2)
  }), 0)])])]), _vm._v(" "), _c('hr')]), _vm._v(" "), (_vm.barchart.length > 0) ? _vm._l(([
    [0, 1],
    [2, 3],
    [4]
  ]), function(pair, index) {
    return _c('div', {
      staticClass: "page-block",
      attrs: {
        "slot": "raw-body"
      },
      slot: "raw-body"
    }, [(index === 0) ? [_c('h2', [_vm._v("Portfolioaufteilung")]), _vm._v(" "), _c('hr', {
      staticStyle: {
        "margin-bottom": "15px"
      }
    })] : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, _vm._l((pair), function(barchartIndex) {
      return (_vm.barchart[barchartIndex]) ? _c('div', {
        staticClass: "column is-half",
        staticStyle: {
          "float": "left",
          "margin-bottom": "20px"
        }
      }, [_c('chart-container', {
        attrs: {
          "chart-data": _vm.barchart[barchartIndex].data,
          "heading": _vm.barchart[barchartIndex].label,
          "settings": _vm.barChartSettings,
          "chart-type": "ChartHorizontalBar"
        }
      }), _vm._v(" "), _c('span', {
        staticStyle: {
          "color": "#666",
          "margin-top": "10px",
          "float": "right"
        }
      }, [_vm._v(_vm._s(_vm.barchart[barchartIndex].info))])], 1) : _vm._e()
    }), 0)], 2)
  }) : _vm._e(), _vm._v(" "), (_vm.template.config.disclaimer.body.length > 0) ? _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('textblock', {
    attrs: {
      "data": _vm.template.config.disclaimer
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.template.config.longDisclaimer && _vm.template.config.longDisclaimer.body.length > 0) ? _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('pagebreak')], 1) : _vm._e(), _vm._v(" "), (_vm.template.config.longDisclaimer && _vm.template.config.longDisclaimer.body.length > 0) ? _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('textblock', {
    attrs: {
      "data": _vm.template.config.longDisclaimer
    }
  })], 1) : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-048bc702"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/factsheet/Factsheet.vue
// module id = 651
// module chunks = 0